import { COLOR_PRIMARY as E, COLOR_SECONDARY as R, COLOR_MUTED as _, COLOR_INVERTED as N, COLOR_ACCENT as I, COLOR_SUCCESS as L, COLOR_WARNING as S, COLOR_DANGER as A, COLOR_ACCENT_INVERTED as o, COLOR_SUCCESS_INVERTED as D, COLOR_DANGER_INVERTED as t, COLOR_INFO as T, COLOR_INFO_INVERTED as m, SIZE_SMALL as M, SIZE_MEDIUM as r, SIZE_LARGE as c } from "./watson.es38.js";
import O from "./watson.es66.js";
const s = [
  E,
  R,
  _,
  N,
  I,
  L,
  S,
  A,
  o,
  D,
  t,
  T,
  m
], e = Object.keys(O).sort();
e.map(
  (C) => O[C].componentName
);
const V = [M, r, c];
export {
  s as ICON_BASE_COLORS,
  O as ICON_MAP,
  e as ICON_NAMES,
  V as ICON_SIZES
};
